import React from "react";
import { css, StyleSheet } from "aphrodite";

const LoadingFallback = ({ 
  height = "300px", 
  message = "Yükleniyor...", 
  showSpinner = true,
  variant = "default" // default, skeleton, minimal
}) => {
  const renderContent = () => {
    switch (variant) {
      case "skeleton":
        return (
          <div className={css(styles.skeletonContainer)}>
            <div className={css(styles.skeletonLine, styles.skeletonTitle)}></div>
            <div className={css(styles.skeletonLine, styles.skeletonSubtitle)}></div>
            <div className={css(styles.skeletonGrid)}>
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className={css(styles.skeletonCard)}>
                  <div className={css(styles.skeletonImage)}></div>
                  <div className={css(styles.skeletonText)}></div>
                </div>
              ))}
            </div>
          </div>
        );
      
      case "minimal":
        return (
          <div className={css(styles.minimalContainer)}>
            <div className={css(styles.minimalDots)}>
              <div className={css(styles.dot, styles.dot1)}></div>
              <div className={css(styles.dot, styles.dot2)}></div>
              <div className={css(styles.dot, styles.dot3)}></div>
            </div>
          </div>
        );
      
      default:
        return (
          <div className={css(styles.defaultContainer)}>
            {showSpinner && (
              <div className={css(styles.spinner)}>
                <div className={css(styles.spinnerInner)}></div>
              </div>
            )}
            <p className={css(styles.message)}>{message}</p>
          </div>
        );
    }
  };

  return (
    <div className={css(styles.container)} style={{ minHeight: height }}>
      {renderContent()}
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    backgroundColor: "#fff",
  },
  
  // Default variant styles
  defaultContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: "40px",
    height: "40px",
    marginBottom: "15px",
  },
  spinnerInner: {
    width: "100%",
    height: "100%",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #88c000",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  message: {
    margin: 0,
    color: "#666",
    fontSize: "14px",
    fontWeight: "500",
  },
  
  // Skeleton variant styles
  skeletonContainer: {
    width: "100%",
    maxWidth: "1200px",
    padding: "20px",
  },
  skeletonLine: {
    height: "20px",
    backgroundColor: "#e9ecef",
    borderRadius: "4px",
    marginBottom: "15px",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  skeletonTitle: {
    width: "60%",
    height: "28px",
    marginBottom: "10px",
  },
  skeletonSubtitle: {
    width: "40%",
    height: "20px",
    marginBottom: "30px",
  },
  skeletonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
  },
  skeletonCard: {
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    overflow: "hidden",
  },
  skeletonImage: {
    height: "200px",
    backgroundColor: "#e9ecef",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  skeletonText: {
    height: "20px",
    backgroundColor: "#e9ecef",
    margin: "15px",
    borderRadius: "4px",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  
  // Minimal variant styles
  minimalContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  minimalDots: {
    display: "flex",
    gap: "8px",
  },
  dot: {
    width: "12px",
    height: "12px",
    backgroundColor: "#88c000",
    borderRadius: "50%",
    animation: "bounce 1.4s ease-in-out infinite both",
  },
  dot1: {
    animationDelay: "-0.32s",
  },
  dot2: {
    animationDelay: "-0.16s",
  },
  dot3: {
    animationDelay: "0s",
  },
  
  // Animations
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
  "@keyframes pulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.5 },
    "100%": { opacity: 1 },
  },
  "@keyframes bounce": {
    "0%, 80%, 100%": {
      transform: "scale(0)",
    },
    "40%": {
      transform: "scale(1.0)",
    },
  },
});

export default LoadingFallback;


// WEBPACK FOOTER //
// ./src/components/shared/LoadingFallback.js